<template>
    <router-link
        :to="{ name: routeName, params: routeParams }"
        :class="[
            getButtonTypeClasses(),
            disabled ? 'opacity-50 cursor-not-allowed' : ''
        ]"
        class="inline-block font-medium py-[16px] px-[20px] rounded text-center"
    >
        <span v-if="iconLeft" class="mr-2 text-sm font-normal">
            <i :class="iconLeft" class="fas"></i>
        </span>
        {{ title }}
        <span v-if="iconRight" class="ml-2 text-sm font-normal">
            <i :class="iconRight" class="fas"></i>
        </span>
    </router-link>
</template>

<script setup lang="ts">
type ButtonType = 'Primary' | 'Secondary' | 'Critical';

interface Props {
    title: string;
    routeName: string;
    routeParams?: Record<string, string | number>;
    iconLeft?: string;
    iconRight?: string;
    disabled?: boolean;
    buttonType?: ButtonType;
}

const props = withDefaults(defineProps<Props>(), {
    routeParams: () => ({}),
    iconLeft: "",
    iconRight: "",
    disabled: false,
    buttonType: 'Primary'
});

const getButtonTypeClasses = () => {
    switch (props.buttonType) {
        case 'Primary':
            return 'bg-action text-inverse-emphasis';
        case 'Secondary':
            return 'bg-white text-action border border-action';
        case 'Critical':
            return 'bg-red-600 text-white';
        default:
            return 'bg-action text-inverse-emphasis';
    }
};
</script>